import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ParadigmaGoogleMap from '../../components/ParadigmaGoogleMap/ParadigmaGoogleMap';

class ModalMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: null,
            lng: null,
            isOpen: false
        }
    }

    static propTypes = {
        onChange: PropTypes.func.isRequired
    }

    toggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    
    onSubmit = () => {
        const { lat, lng } = this.state;
        this.props.onChange(lat, lng);
        this.toggle();
    }

    onPositionChange = position => this.setState({ lat: position.lat, lng: position.lng });

    render() {
        const { lat, lng } = this.state;
        return (
            <Fragment>
                <div className="ui-map-action-row">
                    <Button
                        className="ui-map-action-button"
                        onClick={this.toggle}
                        color="primary"
                    >
                        <i className="fa fa-map-marker"></i>{' '}
                        Ubicar en el mapa
                    </Button>
                </div>

                <Modal toggle={this.toggle} isOpen={this.state.isOpen} className="ui-paradigma-modal ui-paradigma-modal-wide">
                    <ModalHeader>
                        Obtener ubicación
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Ubicación</p>
                            <p className="ui-map-help">Haga click en el mapa para seleccionar una ubicación.</p>
                            <div className="ui-map-preview">
                                <ParadigmaGoogleMap
                                    positionSelector
                                    height="400px"
                                    type="hybrid"
                                    onChange={this.onPositionChange}
                                />
                            </div>
                        </section>

                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancelar</Button>
                        <Button color="success" onClick={this.onSubmit} disabled={!lat && !lng}>Establecer</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default ModalMap;



// WEBPACK FOOTER //
// ./src/views/Loteos/ModalMap.js